import React, {useState, useRef, useEffect, useMemo, useCallback, Fragment, useContext} from 'react';
import {VisDiv } from '..';
import {useStateContext} from '../../context/StateContext';
import { formattedNumber } from '../../lib/utils'; 
import RichTextEditor from '../RichTextEditor';

/**
 * A single pin field component for the GroupedPin component. #offers
 * 
 * @param {boolean} edit - Whether the component should be in edit mode or not.
 * @param {boolean} viewOnlyItem - Whether the component should only show the value of the item or not.
 * @param {Array} visibleLocations - The list of visible locations.
 * @param {Object} item - The item document.
 * @param {Object} priceListItem - The price list document.
 * @param {string} objKey - The key of the object field.
 * @param {Function} setItem - The function to set the item document.
 * @param {boolean} richEditor - Whether the component should use a rich text editor or not.
 * @param {string} prefix - The prefix string to show before the value.
 * @param {string} suffix - The suffix string to show after the value.
 * @param {Object} loadedProduct - The loaded product document.
 * @param {string} numberFormat - The number format to use.
 * @param {string} fieldType - The type of the field (textArea, text, number).
 */
export const PinField = ({edit, viewOnlyItem, visibleLocations, item, priceListItem, objKey, setItem=()=>{}, richEditor=false, prefix, suffix, loadedProduct, numberFormat, fieldType}) => {

    const {sUser} = useStateContext()
    const [value, setValue] = useState(item)
    const [labourHours, setLabourHours] = useState(value?.[objKey]/priceListItem?.price)
    //useEffect(()=>{setValue(item)},[item])
    useEffect(()=>{
      if(loadedProduct) {
        setValue(loadedProduct)
        setItem({order:item?.order, [objKey]: loadedProduct[objKey], _id: item?._id}, objKey);
        //console.log("USE EFFECT IN PIN FIELD", loadedProduct)
      }
    },[loadedProduct])
  
    const searchRef = useRef();
  
    //useAutoSizeTextArea(searchRef, text, value);
  
    const onSearchClick = (e) => {
      e.stopPropagation()
    };
    const objValue = viewOnlyItem?.[objKey] ? viewOnlyItem?.[objKey] : item?.[objKey]
  
    const onType = (e) => {
      e.stopPropagation()
      item?.[objKey]
      const newLine = {...item, [objKey]: e.target.value}
      setItem({order:item?.order, [objKey]: e.target.value, _id: item?._id}, objKey);
      setValue(newLine)
      //console.log('Text inside div', newLine)
    };
    const hoursBlur = (e) => {
      e.stopPropagation()
      item?.[objKey]
      const newPrice = (labourHours * priceListItem?.price)?.toFixed(2).toString()
      const newLine = {...item, [objKey]:newPrice }
      setItem({order:item?.order, [objKey]: newPrice, _id: item?._id}, objKey);
      setValue(newLine)
    }
   
    const editorDoc = (data) => {
     //console.log("EDITOR LOG IN PARENT", data, objKey)
      setItem({order:item?.order, [objKey]: data, _id: item?._id}, objKey);
    }
  
    const testFunction = () => {
    //console.log("test f", item, item[objKey], "loaded product", loadedProduct[objKey], "value", value)
    console.log("test inside pin field", {item, priceListItem, objKey, valueObjKey: item?.[objKey], loadedProduct: loadedProduct?.[objKey], value: value})
    }
  
    const inputType = numberFormat ? "number" : "text"
   

  
  // QUANTITY OF LABOUR HAS TO BE 1
   if(item?.labourProduct && objKey == "quantity") return 1
  
   if(objKey == "location" && !edit) {
    if(visibleLocations?.length > 0) return visibleLocations?.toString()
    return objValue
   }
  
    return (
    <div>
      <VisDiv rules={[false, edit, item?.labourProduct, objKey == "unitPrice"]}>
        <button onClick={testFunction}>test cell</button>
      </VisDiv>
      <div style={{display:"flex"}}>
        <VisDiv rules={[richEditor && objKey == "law"]}>
          <VisDiv rules={[(value?.["lawLabel"]&& edit) || !value?.["lawLabel"]]}>
            <RichTextEditor existingDoc={value?.[objKey]} readOnly={!edit} editorDoc={editorDoc} updateInitialData={true}/>
          </VisDiv>
          <VisDiv rules={[!edit , value?.["lawLabel"]]}>
              {value?.["lawLabel"]}
            </VisDiv>
        </VisDiv>
      
        <VisDiv rules={[richEditor && objKey !== "law"]}>
          <RichTextEditor existingDoc={value?.[objKey]} readOnly={!edit} editorDoc={editorDoc} updateInitialData={true}/>
        </VisDiv>
        
        <VisDiv style={{display:"flex"}} rules={[!richEditor, !edit]}>
          <VisDiv rules={[prefix, false]}>
            {`${prefix}`}
          </VisDiv>
          {numberFormat ? formattedNumber(objValue, numberFormat) : objValue}
          <VisDiv rules={[suffix, false]}>
            {`${suffix}`}
          </VisDiv>
          
        </VisDiv>
      
        <VisDiv style={{display:"flex", padding: "5px", fontSize: 16}} rules={[!richEditor, edit]}>
          <VisDiv style={{display:"flex",alignItems:"center",marginRight:"3px"}} rules={[prefix]}>
            {`${prefix}`}
          </VisDiv>
          <VisDiv style={{display:"flex",alignItems:"center"}} rules={[fieldType == "textArea"]}>
              <textarea 
                type={inputType}
                onClick={(e)=>onSearchClick(e)} 
                style={{fontSize:"12px", width: "100%", backgroundColor: `rgba(0, 0, 0, 0)`, padding: "5px", outline:"none", border: "1px solid #ccc", borderRadius: "5px"}} 
                onChange={onType} 
                value={value?.[objKey]} 
                ref={searchRef} />
          </VisDiv>
          <VisDiv style={{ marginTop:"7px",}} rules={[!fieldType]}>
              <input 
                type={inputType}
                onClick={(e)=>onSearchClick(e)} 
                style={{fontSize:"12px", width: "100%", backgroundColor: `rgba(0, 0, 0, 0)`, padding: "5px", outline:"none", border: "1px solid #ccc", borderRadius: "5px"}} 
                onChange={onType} 
                value={value?.[objKey]} 
                ref={searchRef} />
          </VisDiv>
          <VisDiv style={{marginLeft:"3px", display:"flex",alignItems:"center"}} rules={[suffix]}>
            {`${suffix}`}
          </VisDiv>
        </VisDiv>
      </div>
      <VisDiv rules={[edit, item?.labourProduct, priceListItem?.price, objKey == "unitPrice"]}>
        <p>Ore Manodopera</p>
        <VisDiv rules={[!fieldType]}>
              <input 
                type={inputType}
                onClick={(e)=>onSearchClick(e)} 
                style={{fontSize:"12px", width: "100%", backgroundColor: `rgba(0, 0, 0, 0)`, padding: "5px", outline:"none", border: "1px solid #ccc", borderRadius: "5px"}} 
                onChange={(e)=>{setLabourHours(e.target.value)}} 
                onBlur={hoursBlur}
                value={(labourHours)} 
                ref={searchRef} />
          </VisDiv>
      </VisDiv>
    </div>
    )
  
  }